import r from '@/utils/request'

/**
 * 发送邮箱验证码
 * @param data 请求参数
 * @returns 响应数据
 */
export const sendEmailCodeApi = (data: ISendEmailCodeReq) => {
  return r.post('/app/user/sendEmailCode', data)
}

/**
 * 注册接口
 * @param data 请求参数
 * @returns 响应数据
 */
export const registerApi = (data: IUserRegisterReq) => {
  return r.post('/app/user/register', data)
}

/**
 * 登录接口
 * @param data 请求参数
 * @returns 响应数据
 */
export const loginApi = (data: IUserLoginReq) => {
  return r.post<IUserLoginRes>('/app/user/login', data)
}

/**
 * 获取用户信息接口
 * @returns 响应数据
 */
export const getUserInfoApi = () => {
  return r.get<IUserInfo>('/app/user/info')
}

/**
 * 创建知识库接口
 * @returns 响应数据
 */
export const createDatasetApi = () => {
  return r.post<IUserInfo>('/app/user/dateset')
}

/**
 * 获取知识库集合接口
 * @returns 响应数据
 */
export const getDatasetCollectionApi = () => {
  return r.get<IDatasetCollection[]>('/app/user/dataset/collection')
}

/**
 * 删除知识库接口
 * @param collectionId 知识库集合ID
 * @returns 响应数据
 */
export const deleteDatasetCollectionApi = (collectionId: string) => {
  return r.delete(`/app/user/dataset/collection/${collectionId}`)
}

/**
 * 创建文件集合接口
 * @param file 上传文件
 * @param data 知识库相关参数
 * @returns 响应数据
 */
export const createFileDatasetCollectionApi = (
  file: File,
  data?: ICreateDatasetCommonForm,
) => {
  return r.upload('/app/user/dataset/collection/localFile', file, {
    data: JSON.stringify(data ?? {}),
  })
}

/**
 * 创建文本集合接口
 * @param data 请求参数
 * @returns 响应数据
 */
export const createTextDatasetCollectionApi = (data: ICreateTextDatasetCollectionReq) => {
  return r.post('/app/user/dataset/collection/text', data)
}

/**
 * 创建链接集合接口
 * @param data 请求参数
 * @returns 响应数据
 */
export const createLinkDatasetCollectionLinkApi = (data: ICreateLinkDatasetCollectionLinkReq) => {
  return r.post('/app/user/dataset/collection/link', data)
}

/**
 * 获取上传oss ststoken
 * @returns 响应数据
 */
export const getUploadOssStstokenApi = () => {
  return r.get<IGetUploadOssStstokenRes>('/app/sys/file/getStsToken')
}
